import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { take, filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-reminder-popup',
  templateUrl: './reminder-popup.component.html',
  styleUrls: ['./reminder-popup.component.scss']
})
export class ReminderPopupComponent implements OnDestroy {

  sanitizedUrl: string = '';


  url = '';


  textAccount: string;
  data: any;
  title: any;
  message: any;
  taskType: any;

  constructor(
    public router: Router,
    private ecryptService: EcryptServiceService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public crmsetting: CrmsettingsService,
    @Inject(MAT_DIALOG_DATA) data,
    public dialogRefnew: MatDialogRef<ReminderPopupComponent>,

  ) {
    this.data = data
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  type: any;

  crmType: any = 0;

  ngOnInit(): void {

    this.textAccount = 'Ok';

    this.title = this.data.data.Title;

    this.type = this.data.data.type;

    this.message = this.data.data.message;


    this.taskType = this.data.data.taskType || 0;

    this.getCrmSettings();

  }

  getCrmSettings() {
    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const res = JSON.parse(decrypted);

        if (res != null) {
          this.crmType = res['crmType'];
          localStorage.setItem(Constant.LEAD_POPUP, res['enableInCallNotification']);


          console.log("10");

          if (res['filterType'] != undefined) {
            let filterType = res['filterType'];
            localStorage.setItem('filterType', filterType);
          }
          if (res['gridType'] != undefined) {
            let gridType = res['gridType'];
            localStorage.setItem('gridType', gridType);
          }

        }

      }
      catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  submit() {


    this.dialogRefnew.afterClosed().pipe(take(1)).subscribe(() => {
      if (this.type === 3 || this.type === 2 || this.type === 8 || this.type === 9 || this.type === 10) {

        if (this.taskType == 2 && this.type === 9) {

          if (this.router.url.includes("/companiesDetail")) {

            let leadId = this.route.snapshot.params['leadId'];

            if (leadId == this.data.data.leadId) {


            } else {

              this.router.navigate(['/companiesDetail/', this.data.data.leadId]);

            }


          } else {

            this.router.navigate(['/companiesDetail/', this.data.data.leadId]);


          }



        } else {

          if (this.router.url.includes("/leadDetail/")) {


            let leadId = this.route.snapshot.params['leadId'];

            if (leadId == this.data.data.leadId) {


            } else {

              if (this.crmType !== 4) {


                this.router.navigate(['/leadDetail/', this.data.data.leadId]);
              } else {
                this.router.navigate(['/lead']);
              }

            }


          }


          else {

            if (this.crmType !== 4) {


              this.router.navigate(['/leadDetail/', this.data.data.leadId]);
            } else {
              this.router.navigate(['/lead']);
            }
          }

        }

      }


    });

    this.dialogRefnew.close();

  }


  close() {
    this.dialogRefnew.close();
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
